import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Modal, ModalBody,
  Row, Col
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

// constant
import { messages } from '../../constants/constant.message';

// css
import './DeleteSalesModal.css';

class DeleteSalesModal extends React.Component {


  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.props.closeModal();
  }

  render() {
    return (
      <div>
        <Modal
          id="delete-sales-modal"
          isOpen={this.props.show}
          toggle={this.closeModal}
          className={this.props.className}
          centered
        >
          <ModalBody>
            <br />
            <Row>
              <Col xs="2">
                <FontAwesomeIcon className="arrow-color" style={{ fontSize: '50px', color: '#ffb609' }} icon={faExclamationTriangle} />
              </Col>
              <Col xs="10">
                <div className="modal-title">Delete Sales</div>
                <div className="modal-text margin-top-10">{messages.DELETE_SALES}</div>
                {/* <br /> */}
                {/* <div>
                  <label class="container-cb">
                    <input
                      type="checkbox"
                      name="checkbox-logout"
                      id="checkbox-logout"
                      checked={this.state.logoutFromAll}
                      onChange={this.setLogoutFromAllCheckboxValue} />{' '}
                    Logout from all device
                    <span class="checkmark"></span>
                  </label>
                </div> */}
              </Col>
            </Row>
            <br />
            <Row>
              <Col className="text-align-right">
                <Button
                  color="#e0e2e4"
                  style={{ backgroundColor: '#e0e2e4', borderRadius: '25px', fontSize: '16px', fontWeight: 'bold' }}
                  onClick={this.props.closeModal}
                >Cancel
                </Button>{'   '}
                <Button
                  color="#fdbb1f"
                  style={{ backgroundColor: '#fdbb1f', borderRadius: '25px', fontSize: '16px', fontWeight: 'bold' }}
                  onClick={this.props.deleteSales.bind(this, this.props.uuid)}
                >Delete
                </Button>{'   '}
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

DeleteSalesModal.propTypes = {
  show: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  className: PropTypes.any,
};

export default DeleteSalesModal;
